<script>
/**
 * Type        : Business component
 * Title       : 배송상품 목록
 * Description : 배송상품 목록을 보여주는 컴포넌트
 * 
 */

import { ref } from 'vue'
import ParcelInfoForm from "@/components/common/modal/ParcelInfoForm.vue"
import ConsolListModal from "@/components/admin/logis/modal/ConsolListModal.vue"
import PdfPreviewer from '@/components/admin/common/modal/PdfPreview.vue'
import ExportJsonCsv from 'vue-json-csv'
import PackingOwnerChangeDialog from '@/components/admin/logis/modal/PackingOwnerChangeDialog.vue'

export default {
  name: "ParcelList",
  components: {
    ParcelInfoForm,
    ConsolListModal,
    PdfPreviewer,
    ExportJsonCsv,
    PackingOwnerChangeDialog
  },
  props: {
    isDel : String,
    pagination: { type: Object, default: () => ({ page: 1, rowsPerPage: 100, rowsNumber: 0, sortBy: null, descending: true }) },
    loading: Boolean,
  },
  computed: {
    tablePagination: {
      get() { return this.pagination },
      set(pagination) { this.$emit('request-page', pagination) }
    },
    parcelList() {
      return this.$store.getters.getParcelList
    },
    parcelLocationList(){
      return this.$store.getters.getParcelLocationListImport
    },
    tempConsolSummary() {
      const partnerSet = new Set()
      const totalQty = this.tempConsolList.reduce((sum, row) => {
        if (row.partnerName) partnerSet.add(row.partnerName)
        return sum + Number(row.totalQty || row.boxQty || 0)
      }, 0)
      const totalWeight = this.tempConsolList.reduce((sum, row) => {
        return sum + Number(row.weight || row.totalWeight || 0)
      }, 0)

      return {
        orderCount: this.tempConsolList.length,
        selectedCount: this.selectedTempConsolList.length,
        partnerCount: partnerSet.size,
        totalQty,
        totalWeight: Math.round(totalWeight * 100) / 100
      }
    },
  },
  emits: [
    "reload-parcel-list",
    "request-page",
  ],
  data() {
    return {
      authLevel         : '00',
      packingOwnerDialogShow: false,
      packingOwnerOrders: [],
      modifyModalShow   : false,
      pdfModalShow      : false,
      consolModalShow   : false,
      tempListModalShow : false,
      trackingModalShow : false,
      trackingLoading   : false,
      trackingTarget    : null,
      trackingInfo      : null,
      tempConsolList    : [],
      tempConsolLoading : false,
      selectedTempConsolList: ref([]),
      tempConsolColumns : [
        { name: 'tempConsolReadyAt', label: '대기등록', align: 'center', field: 'tempConsolReadyAt', sortable: true },
        { name: 'packingCompletedAt', label: '포장완료', align: 'center', field: 'packingCompletedAt', sortable: true },
        { name: 'partnerName', label: '파트너', align: 'center', field: 'partnerName', sortable: true },
        { name: 'orderId', label: 'Order No.', align: 'center', field: 'orderId', sortable: true },
        { name: 'hblNo', label: 'H B/L No.', align: 'center', field: 'hblNo', sortable: true },
        { name: 'receiverName', label: '수취인', align: 'center', field: 'receiverName' },
        { name: 'itemNames', label: '상품명', align: 'left', field: 'itemNames' },
        { name: 'totalQty', label: '수량', align: 'center', field: 'totalQty' },
        { name: 'weight', label: '실무게', align: 'center', field: 'weight' },
        { name: 'freightMethod', label: '운송', align: 'center', field: 'freightMethod', format: val => `${(val == 1 ? '해상' : val == 2 ? '항공' : '-')}` },
      ],

      selectedList      : ref([]),  // 선택된 parcel을 저장
      columns : [
        {
          name: 'rownum',
          label: 'ID',
          align: 'center',
          field: 'id',
          format: val => `${val}`,
          sortable: true
        },
        {
          name: '출력여부',
          label: '출력여부',
          align: 'center',
          field: 'isPrinted',
          format: val => `${val}`
        },
        { name: 'statusName', label: '진행상태', align: 'center', field: 'statusName', sortable: true },
        { name: 'packingOwner', label: '포장주체', align: 'center', field: 'packingOwner', format: val => this.getPackingOwnerLabel(val), sortable: true },
        { name: 'packingStatus', label: '포장상태', align: 'center', field: 'packingStatus', sortable: true },
        { name: 'tempConsolStatus', label: '콘솔상태', align: 'center', field: 'tempConsolStatus', sortable: true },
        { name: 'trackingState', label: '배송조회', align: 'center', field: 'trackingState', sortable: true },
        { name: 'regName', label: '등록자명', align: 'center', field: 'regName' },
        
        { name: 'partnerName', label: '파트너명', align: 'center', field: 'partnerName' },
        
        { name: 'orderId', label: 'Order No.', align: 'center', field: 'orderId' },
        { name: 'hblNo', label: 'H B/L No.', align: 'center', field: 'hblNo' },
        { name: 'mblNo', label: 'M B/L No.', align: 'center', field: 'mblNo' },
        
        // { name: 'customerName', label: '회원명', align: 'center', field: 'customerName' },
        
        { name: 'shipperName', label: '보내는 사람명', align: 'center', field: 'shipperName' },
        { name: 'receiverName', label: '받는 사람명', align: 'center', field: 'receiverName' },
        { name: 'pcc', label: '개인통관고유번호', align: 'center', field: 'pcc' },
        { name: 'receiverMobile', label: '받는 사람 연락처', align: 'center', field: 'receiverMobile', format: val => this.$formatPhoneNumber(val, 'mobile')},

        { name: 'itemNames', label: 'Description', align: 'left', field: 'itemNames' },
        { name: 'totalPrice', label: '총가격', align: 'center', field: 'totalPrice' },
        { name: 'totalQty', label: '박스수량', align: 'center', field: 'totalQty' },
        { name: 'totalWeight', label: '상품무게(kg/CBM)', align: 'center', field: 'totalWeight' },

        { name: 'weight', label: '실무게(kg)', align: 'center', field: 'weight' },

        { name: 'freightMethod', label: '운송수단', align: 'center', field: 'freightMethod', format: val => `${(val == 1 ? '해상' : val == 2 ? '항공' : '')}` },
        { name: 'courierCode', label: '택배사', align: 'center', field: 'courierCode', format: val => `${this.$getCourierName(val)}` },
        { name: 'courierNum', label: '송장번호', align: 'center', field: 'courierNum' },
        
        { name: 'modiDate', label: '최종수정일', align: 'center', field: 'modiDate' },
        { name: 'regDate', label: '등록일', align: 'center', field: 'regDate' },
        
        // { name: 'eatable', label: '음식물여부', align: 'center', field: 'eatable', format: val => `${(val == 0? 'Y' : 'N')}` },
        // 삭제여부 컬럼 숨김
        // { name: 'isDel', label: '삭제여부', align: 'center', field: 'isDel' },
      ],
      

      csvName: 'backup-data-' + new Date().toLocaleDateString() + '.csv',
      
      csvHeaders:{ // Export CSV - 헤더 컬럼 필드 한글 매핑
        id                : 'ID',
        freightMethod     : '운송수단',
        regName           : '등록업체',
        customerNum       : '회원번호',
        customerName      : '회원명',
        bulkShipping      : '묶음배송여부',
        bulkSeq           : '묶음배송번호',
        bulkCnt           : '묶음배송갯수',
        courierCode       : '택배사코드',
        courierName       : '택배사',
        courierNum        : '송장번호',
        parcelStatus      : '화물상태',
        parcelLocation    : '화물위치코드',
        parcelLocationName: '화물위치명',
        parcelCode        : '화물코드',
        destiCity         : '도착지(도시)',
        pickUpLocation    : '픽업위치코드',
        pickUpLocationName: '픽업위치명',
        deliveryAddress   : '도착지주소',
        email             : '수취인 이메일',
        eatable           : '음식물여부',
        length            : '길이(cm)',
        height            : '높이(cm)',
        width             : '넓이(cm)',
        memo              : '메모',
        isDel             : '삭제여부',
        actualWeight      : '실무게(kg)',
        weight            : '부피무게(kg/CBM)',
        receiver          : '수취인',
        mobileCountry     : '수취인 국가코드',
        mobileNum         : '수취인 전화번호',
        pickupLocation    : '픽업지',
        parcelLocatonName : '위치',
        regDateOriginal   : '등록일전체',
        regDate           : '등록일',
      },

      userType: 'admin'
    }
  },
  methods:{
    openPackingOwnerDialog() {
      if (Number(this.authLevel) < 90 || this.loading || !this.selectedList.length || this.isDel !== '0') return
      this.packingOwnerOrders = this.selectedList.map(row => ({ ...row }))
      this.packingOwnerDialogShow = true
    },
    refreshAfterPackingOwnerChange() {
      this.selectedList = []
      this.$emit('reload-parcel-list')
    },
    clearSelection() { this.selectedList = [] },
    requestPage({ pagination }) {
      if (!this.loading) this.$emit('request-page', pagination)
    },
    getPackingStatusColor(value) {
      if (value === 'COMPLETED') return 'positive'
      if (value === 'IN_PROGRESS') return 'warning'
      if (value === 'READY') return 'primary'
      return 'grey-6'
    },
    getPackingStatusLabel(row = {}) {
      const status = String(row.packingStatus || '').trim().toUpperCase()
      if (status === 'COMPLETED') return '포장완료'
      if (status === 'IN_PROGRESS') return '포장중'
      if (status === 'READY') return '대기'
      return '-'
    },
    getTempConsolStatusLabel(value) {
      if (value === 'READY') return '연결대기'
      if (value === 'LINKED') return '연결완료'
      return '미등록'
    },
    getTempConsolStatusColor(value) {
      if (value === 'READY') return 'yellow-9'
      if (value === 'LINKED') return 'teal-7'
      return 'grey-6'
    },
    getTempConsolIneligibleReason(row) {
      if (String(row?.packingStatus || '').toUpperCase() !== 'COMPLETED') return '포장 미완료'
      if (row?.consoleId !== null && row?.consoleId !== undefined) return '이미 콘솔 연결됨'

      const status = String(row?.tempConsolStatus || 'NONE').toUpperCase()
      if (status === 'READY') return '이미 임시콘솔 대기 중'
      if (status === 'LINKED') return '이미 콘솔 연결 완료'
      return ''
    },
    getPackingOwnerLabel(value) {
      const owner = String(value || 'PARTNER').trim().toUpperCase()
      if (owner === 'AONE') return 'AONE'
      if (owner === 'PARTNER') return '파트너'
      return '-'
    },
    getPackingOwnerColor(value) {
      const owner = String(value || 'PARTNER').trim().toUpperCase()
      if (owner === 'AONE') return 'deep-purple-7'
      if (owner === 'PARTNER') return 'blue-grey-7'
      return 'grey-6'
    },
    getTrackingStatusColor(value) {
      if (value === '배달완료') return 'positive'
      if (!value) return 'grey-5'
      if (String(value).includes('오류')) return 'negative'
      return 'blue-7'
    },
    normalizeTrackingResponse(data = {}) {
      const status = data.status || data.tracking || data
      let details = status.detail_json || status.details || []
      if (typeof details === 'string') {
        try {
          details = JSON.parse(details)
        } catch {
          details = []
        }
      }
      return {
        ...status,
        details: Array.isArray(details) ? details : []
      }
    },
    async openTrackingModal(row) {
      if (!row?.id || !row?.hblNo) {
        this.$q.notify({
          type: 'warning',
          message: '조회할 H/BL 번호가 없습니다.',
          position: 'top',
          timeout: 3000,
        })
        return
      }

      this.trackingTarget = row
      this.trackingInfo = null
      this.trackingModalShow = true
      this.trackingLoading = true

      try {
        const res = await this.$http({
          method: 'GET',
          url: `/api/parcel/tracking/${row.id}`,
          name: '[ Axios / 배송조회 상태 조회 ]',
          skipSpinner: true
        })
        this.trackingInfo = this.normalizeTrackingResponse(res?.data?.data?.status || {})
      } catch (err) {
        this.$log.error('[ 배송조회 상태 조회 실패 ]', err)
        this.$q.notify({
          type: 'negative',
          message: err?.response?.data?.message || '배송조회 상태 조회에 실패했습니다.',
          position: 'top',
          timeout: 3000,
        })
      } finally {
        this.trackingLoading = false
      }
    },
    async refreshTracking() {
      if (!this.trackingTarget?.id || this.trackingLoading) return

      this.trackingLoading = true
      try {
        const res = await this.$http({
          method: 'POST',
          url: `/api/parcel/tracking/${this.trackingTarget.id}/refresh`,
          data: {},
          name: '[ Axios / 배송조회 수동 재조회 ]',
          skipSpinner: true
        })
        this.trackingInfo = this.normalizeTrackingResponse(res?.data?.data?.tracking || {})
        this.$q.notify({
          type: 'positive',
          message: '배송조회 정보를 갱신했습니다.',
          position: 'top',
          timeout: 3000,
        })
        this.$emit('reload-parcel-list')
      } catch (err) {
        this.$log.error('[ 배송조회 수동 재조회 실패 ]', err)
        this.$q.notify({
          type: 'negative',
          message: err?.response?.data?.message || '배송조회 수동 재조회에 실패했습니다.',
          position: 'top',
          timeout: 4000,
        })
      } finally {
        this.trackingLoading = false
      }
    },
    /**
     * Title        : 일괄삭제
     * Status       : Actived
     * Description  : 선택된 복수의 택배 삭제를 한다.
     *                삭제시 확인 얼럿을 띄우고 이후 삭제를 실행한다.
     *                선택된 length가 0일 경우. 실패
     */
    bulkDelete () {
      // 콘솔에 포함된 오더(콘솔Id가 있는 항목)가 있는지 확인하고, 있으면 해당 HBL No들을 배열로 emit(반환)하고 중단하지 않음
      let hblNos = []
      const blocked = (this.selectedList).filter(item => {  
        return item.mblNo 
      });

      if (blocked.length > 0) {
        hblNos = blocked.map(i => i.hblNo).filter(Boolean)
      }
      this.$log.debug('[ hblNos ] = ', hblNos)

      let msg = `삭제 이후에는 삭제목록으로 관리할 수 있습니다.`
      msg += hblNos.length ? 
      `<br/><br/>
      !! H B/L No: ${hblNos.join(', ')} 은 콘솔에 포함되어 있습니다.<br/>
      삭제하는 경우 콘솔에서 제외됩니다.
      ` : '';

      this.$q.dialog({
        title: '삭제하시겠습니까?',
        message: msg,
        cancel: true, // 취소 버튼 보임
        persistent: true, // ESC로 닫기 방지 (옵션)
        html: true
      }).onOk(() => {
        // 확인 눌렀을 때
        let idArr = this.selectedList.map(item => {
          return item.id
        })
  
        this.$log.debug("[ 일괄삭제 실행 / idArr ] = ", idArr)
  
        let payload = {
          id : idArr
        }
  
        this.delete(payload, '1')
      });
    },
    
    /**
     * Title        : 일괄복구
     * Status       : Actived
     * Description  : 삭제된 배송상품 선택하여 복구
     */
    reactivate () {
      let idArr = this.selectedList.map(item => {
        return item.id
      })

      this.$log.debug("[ 일괄복구 실행 / idArr ] = ", idArr)

      let payload = {
        id : idArr
      }

      this.delete(payload, '0')
    },

    /**
     * Title        : 삭제/복구 실행 메소드
     * Status       : Actived
     * Description  : 선택된 화물 삭제/복구 실행한다.
     */
    async delete (payload, type) {

      let newPayload = Object.assign( payload, { isDel : type }); 

      let config = {
        method  : "POST",
        url     : "/api/parcel/delete",
        data    : newPayload,
        name    : "[ Axios / ParcelList / 배송상품 삭제 실행 ]"
      }

      await this.$http(config)
        .then(() => {
          this.$log.debug("삭제했습니다.")

          this.$emit('reload-parcel-list')

          this.$q.notify({
            type: 'positive',
            message: type == '0' ? "복구되었습니다" : "삭제되었습니다",
            position: 'top',
            timeout: 3000,
          })
        })
        .catch((err) => {
          this.$log.debug(err)
          this.$q.notify({
            type: 'negative',
            message: '불러오기 실패!',
            position: 'top',
            timeout: 3000,
          })
        })
        .finally(() => {
          this.selectedList = []
        }
      )
    },

    /**
     * Title        : 일괄위치변경
     * Status       : Actived
     * Description  : 선택된 화물의 위치 일괄변경
     */
    async bulkChangeStatus(status){
      
      let idArr = this.selectedList.map(item => {
        return item.id
      })
      
      this.$log.debug(status)
      this.$log.debug("idArr = ", idArr)

      
      let payload = {
        id      : idArr, 
        status  : status
      }

      let config = {
        method  : "POST",
        url     : "/api/parcel/modifyOrderStatus",
        data    : payload,
        name    : "[ Axios / ParcelList / 배송상품 위치 일괄 변경 ]"
      }

      await this.$http(config)
        .then(() => {
          this.$log.debug("위치정보를 변경했습니다.")
          this.selectedList = []

          this.$emit('reload-parcel-list')

          this.$q.notify({
            type: 'positive',
            message: '선택된 ORDER의 진행상태가 변경되었습니다.',
            position: 'top',
            timeout: 3000,
          })
        })
        .catch((err) => {
          this.$q.notify({
            type: 'positive',
            message: '선택된 ORDER의 진행상태가 변경을 실패했습니다.',
            position: 'top',
            timeout: 3000,
          })
          this.$log.debug(err)
      })

    },

    /**************************
     * PDF 관련기능
     **************************/
    pdfModalControl(){
      if(this.selectedList.length === 0){
        this.$q.notify({
          type: 'positive',
          message: '선택된 ORDER가 없습니다',
          position: 'top',
          timeout: 3000,
        })
        return false
      }

      const invalidWeightOrders = this.selectedList.filter(item => {
        const weight = Number(item.weight)
        return !Number.isFinite(weight) || weight <= 0
      })
      if (invalidWeightOrders.length > 0) {
        const targetNames = invalidWeightOrders
          .map(item => item.hblNo || item.orderId || item.id)
          .filter(Boolean)
          .join(', ')

        this.$q.notify({
          type: 'negative',
          message: `실제 무게가 입력되지 않아 운송장을 출력할 수 없습니다.${targetNames ? ` 대상: ${targetNames}` : ''}`,
          position: 'top',
          timeout: 5000,
        })
        return false
      }

      this.pdfModalShow = !this.pdfModalShow
    },

    closePdfPreview(){
      this.pdfModalShow = !this.pdfModalShow
    },

    reloadParcelList(){
      this.$emit('reload-parcel-list')
      this.loadTempConsolList()
    },

    // 모달 닫기
    closeModal(){
      this.modifyModalShow = false
      this.tempListModalShow = false
    },


    /**
     * Title        : Row click
     * Status       : Actived
     * Description  : 선택된 화물의 정보를 변경하기 위한 모달 호출
     */
    onRowClick (evt, row) {
      if (this.loading) return
      const interactiveTarget = evt?.target?.closest?.(
        'button, a, input, select, textarea, [role="button"], [role="checkbox"]'
      )
      if (interactiveTarget) return

      this.openParcelDetails(row)
    },

    openParcelDetails (row) {
      this.$log.debug('선택된 화물 = ', row)
      this.selectedList = [row]
      this.modifyModalShow = true
    },

    /**
     * Title        : 묶을 콘솔 목록 호출
     * Status       : Actived
     * Description  : 선택된 화물의 정보를 변경하기 위한 모달 호출
     */
    callConsolModal(type) {
      this.$log.debug("[ 묶을 콘솔 목록 호출 ]")
      if(type === 'inList' && this.selectedList.length === 0){
        this.$q.notify({
          type: 'positive',
          message: '선택된 ORDER가 없습니다',
          position: 'top',
          timeout: 3000,
        })
        return false
      } else if(type === 'inTemp'){
        if(this.selectedTempConsolList.length === 0){
          this.$q.notify({
            type: 'positive',
            message: '선택된 임시콘솔 대상이 없습니다',
            position: 'top',
            timeout: 3000,
          })
          return false
        }

        this.selectedList = this.selectedTempConsolList
      }

      this.consolModalShow = true
    },


    /**
     * Title        : 콘솔해제하기
     * Status       : Actived
     * Description  : 선택된 화물의 Consol 해제하기
     */
    async deConsolize() {
      this.$log.debug("[ De consolize ]")

      if(this.selectedList.length === 0){
        this.$q.notify({
          type: 'positive',
          message: '선택된 ORDER가 없습니다',
          position: 'top',
          timeout: 3000,
        })
        return false
      }
     
      let payload = {
        orderList : this.selectedList.map(item => item.id)
      }

      let config = {
        method  : "POST",
        url     : "/api/consol/deConsolize",
        data    : payload,
        name    : "[ Axios / deConsolize ]"
      }

      await this.$http(config)
        .then((res) => {
          this.$log.debug("콘솔이 해제되었습니다.", res.data)
          
          this.$emit('reload-parcel-list')
          this.selectedList = []

          this.$q.notify({
            type: 'positive',
            message: '콘솔이 해제되었습니다',
            position: 'top',
            timeout: 3000,
          })
        })
        .catch((err) => {
          this.$log.debug(err)
          this.$q.notify({
            type: 'negative',
            message: 'deConsolize 실패!',
            position: 'top',
            timeout: 3000,
          })
      })
    },



    /**
     * Title        : 임시 콘솔목록
     * Status       : Actived
     * Description  : 임시 콘솔목록으로 등록
     */
    async loadTempConsolList () {
      this.tempConsolLoading = true
      try {
        const config = {
          method  : "POST",
          url     : "/api/consol/getTempConsolOrderList",
          data    : {},
          name    : "[ Axios / 임시콘솔목록조회 ]"
        }
        const res = await this.$http(config)
        this.tempConsolList = Array.isArray(res.data) ? res.data : []
        this.selectedTempConsolList = []
      } catch (err) {
        this.$log.error("[ Axios / 임시콘솔목록조회 ] 실패 =>", err)
        this.$q.notify({
          type: 'negative',
          message: '임시콘솔목록 조회에 실패했습니다',
          position: 'top',
          timeout: 3000,
        })
      } finally {
        this.tempConsolLoading = false
      }
    },

    async listingTempConsolList () {
      this.$log.debug("[ 임시 콘솔목록에 추가 ]")

      if(this.selectedList.length === 0){
        this.$q.notify({
          type: 'warning',
          message: '선택된 ORDER가 없습니다',
          position: 'top',
          timeout: 3000,
        })
        return false
      }

      const ineligibleRows = this.selectedList
        .map((row) => ({ row, reason: this.getTempConsolIneligibleReason(row) }))
        .filter((item) => item.reason)

      if (ineligibleRows.length > 0) {
        const summary = ineligibleRows
          .slice(0, 3)
          .map(({ row, reason }) => `${row.orderId || row.id}: ${reason}`)
          .join(', ')
        const more = ineligibleRows.length > 3 ? ` 외 ${ineligibleRows.length - 3}건` : ''

        this.$q.notify({
          type: 'warning',
          message: `포장완료·미등록 주문만 등록할 수 있습니다. ${summary}${more}`,
          position: 'top',
          timeout: 5000,
        })
        return false
      }

      const payload = {
        orderList : this.selectedList.map(item => item.id)
      }

      const config = {
        method  : "POST",
        url     : "/api/consol/markTempConsolReady",
        data    : payload,
        name    : "[ Axios / 임시콘솔목록등록 ]"
      }

      try {
        await this.$http(config)
        await this.loadTempConsolList()
        this.$emit('reload-parcel-list')
        this.selectedList = []
        this.$q.notify({
          type: 'positive',
          message: '임시콘솔목록에 등록되었습니다',
          position: 'top',
          timeout: 3000,
        })
      } catch (err) {
        this.$log.error("[ Axios / 임시콘솔목록등록 ] 실패 =>", err)
        this.$q.notify({
          type: 'negative',
          message: err?.response?.data?.message || '임시콘솔목록 등록에 실패했습니다',
          position: 'top',
          timeout: 5000,
        })
      }
    },

    /**
     * Title        : 임시 콘솔목록
     * Status       : Actived
     * Description  : 임시 콘솔목록으로 등록
     */
    async callTempConsolList () {
      this.$log.debug("[ 임시 콘솔목록 호출 ]")
      await this.loadTempConsolList()

      if(this.tempConsolList.length === 0){
        this.$q.notify({
          type: 'positive',
          message: '임시 콘솔목록이 없습니다',
          position: 'top',
          timeout: 3000,
        })
        return false
      }

      this.tempListModalShow = !this.tempListModalShow
    },

    /**
     * Title        : 임시 콘솔 목록 삭제
     * Status       : Actived
     * Description  : 임시 콘솔 목록 지우기
     */
    emptyConsol() {
      this.$log.debug("[ 임시 콘솔 목록 삭제 ]")
      
      this.$q.dialog({
        message: '임시 콘솔 목록을 비우시겠습니까?',
        ok : { label : '삭제', color : 'negative' },
        cancel: { label : '취소', color : 'grey-5' },
        persistent: true // ESC로 닫기 방지 (옵션)
      }).onOk(async () => { // 직접입력
        const config = {
          method  : "POST",
          url     : "/api/consol/clearTempConsolReady",
          data    : {
            orderList: this.tempConsolList.map(item => item.id)
          },
          name    : "[ Axios / 임시콘솔목록비우기 ]"
        }

        try {
          await this.$http(config)
          await this.loadTempConsolList()
          this.$q.notify({
            type: 'positive',
            message: '임시 콘솔 목록이 삭제되었습니다',
            position: 'top',
            timeout: 3000,
          })
        } catch (err) {
          this.$log.error("[ Axios / 임시콘솔목록비우기 ] 실패 =>", err)
          this.$q.notify({
            type: 'negative',
            message: '임시 콘솔 목록 삭제에 실패했습니다',
            position: 'top',
            timeout: 3000,
          })
        }
      }).onCancel(async () => {
        return false
      })
    },

    clearSelectedTempConsol() {
      this.$log.debug("[ 임시 콘솔 선택 해제 ]")

      if(this.selectedTempConsolList.length === 0){
        this.$q.notify({
          type: 'positive',
          message: '선택된 임시콘솔 대상이 없습니다',
          position: 'top',
          timeout: 3000,
        })
        return false
      }

      this.$q.dialog({
        message: '선택한 임시콘솔 대기 건을 해제하시겠습니까?',
        ok : { label : '해제', color : 'negative' },
        cancel: { label : '취소', color : 'grey-5' },
        persistent: true
      }).onOk(async () => {
        const config = {
          method  : "POST",
          url     : "/api/consol/clearTempConsolReady",
          data    : {
            orderList: this.selectedTempConsolList.map(item => item.id)
          },
          name    : "[ Axios / 임시콘솔선택해제 ]"
        }

        try {
          await this.$http(config)
          await this.loadTempConsolList()
          this.$q.notify({
            type: 'positive',
            message: '선택한 임시콘솔 대기 건이 해제되었습니다',
            position: 'top',
            timeout: 3000,
          })
        } catch (err) {
          this.$log.error("[ Axios / 임시콘솔선택해제 ] 실패 =>", err)
          this.$q.notify({
            type: 'negative',
            message: '임시콘솔 선택 해제에 실패했습니다',
            position: 'top',
            timeout: 3000,
          })
        }
      }).onCancel(async () => {
        return false
      })
    },



    /**
     * Title        : 페이지 초기화
     * Status       : Actived
     * Description  : 페이지 초기화 기능으로 등록된 화물/삭제된 삭제 모드를 변경시킨다.
     * Param (mode)  : 실행된 모드
     */
    init(){
      // 관리자 페이지 이므로 관리자가 아닌 경우 일반사이트로 이동을 시킨다.
      this.authLevel =  this.$getAuthLevel()

      // 오더 상태 불러오기
      this.$getCodeList('ORDSTT')
      // 택배사 목록 불러오기 - 택배사 목록은 코드로 관리하지 않기 때문에 this.$getCodeList()로 불러오지 않는다.
      this.$getCourierList()
      if(Number(this.authLevel) >= 90){
        this.loadTempConsolList()
      }
    }
  },
  mounted(){
    this.init()
  }
}
</script>


<template>

  <div class="row q-mb-sm">
    <div class="col col-8">
      <q-btn v-if="isDel == '0' && Number(authLevel) >= 90" color="primary"
        label="선택 일괄 포장 주체 변경" class="q-mr-sm q-mb-sm"
        :disable="loading || selectedList.length === 0 || packingOwnerDialogShow"
        @click="openPackingOwnerDialog" />
      <!-- 버튼 - 진행상태변경
      <q-btn-dropdown 
        color="primary" 
        class="q-mr-sm q-mb-sm"
        label="진행상태변경">
        <q-list>
          <q-item v-for="(status, index) in this.$store.getters.getOrderStatusCodeList" v-bind:key="index"
            clickable v-close-popup
            @click="bulkChangeStatus(status.value)">
            <q-item-section>
              <q-item-label>{{ status.label }}</q-item-label>
            </q-item-section>
          </q-item>
        </q-list>
      </q-btn-dropdown>
       -->

      <!-- 버튼 - PDF 미리보기 -->
      <q-btn
        color="red"
        class="q-mr-sm q-mb-sm"
        icon="picture_as_pdf"
        @click="pdfModalControl"
        :disable="selectedList.length === 0">
      </q-btn>

      <!-- 버튼 - 콘솔에 묶기 -->
      <q-btn
        v-show="isDel == '0' && authLevel >= 90"
        color="teal-7"
        label="Consol"
        class="q-mr-sm q-mb-sm"
        icon="link"
        @click="callConsolModal('inList')"
        :disable="selectedList.length === 0">
      </q-btn>

      <!-- 버튼 - 콘솔해제하기 -->
      <q-btn
        v-show="authLevel >= 90"
        color="teal-5"
        label="De-consol"
        class="q-mr-sm q-mb-sm"
        icon="link_off"
        @click="deConsolize"
        :disable="selectedList.length === 0">
      </q-btn>

      <br>

      <!-- 버튼 - 임시 콘솔목록 -->
      <q-btn
        v-show="isDel == '0' && authLevel >= 90"
        color="yellow-9"
        label="임시콘솔로 이동하기 =>"
        class="q-mr-sm q-mb-sm"
        @click="listingTempConsolList"
        :disable="selectedList.length === 0">
      </q-btn>

      <!-- 버튼 - 임시 콘솔목록 -->
      <q-btn
        v-show="isDel == '0' && authLevel >= 90"
        color="yellow-9"
        :label="tempConsolList.length === 0 ? '임시콘솔목록' : '임시콘솔목록(' + tempConsolList.length + ')'"
        class="q-mr-sm q-mb-sm"
        icon="list"
        @click="callTempConsolList"
        :loading="tempConsolLoading">
      </q-btn>        
    </div>
    <div class="col text-right">
      <ExportJsonCsv
        style="display: inline-block"
        :data="parcelList" 
        :labels="csvHeaders"
        :name="csvName">

        <!-- 버튼 - 조회된 데이터 백업 -->
        <q-btn
          color="cyan-7"
          label="현재목록백업"
          icon="download"
          class="q-ml-sm q-mb-sm"
          :disable="parcelList.length === 0">
        </q-btn>

      </ExportJsonCsv>


      <!-- 버튼 - 복구버튼 -->
      <q-btn
        v-if="isDel == '1'"
        color="orange"
        label="복구"
        class="q-ml-sm q-mb-sm"
        @click="reactivate">
      </q-btn>


      <!-- 
        버튼 - 삭제버튼 
        관리자만 볼 수 있는 버튼
        Bulk delete가 가능하다
       -->
      <q-btn  
        v-show="isDel == '0' && authLevel >= 90"
        color="red"
        class="q-ml-sm q-mb-sm"
        icon="delete"
        @click="bulkDelete"
        :disable="selectedList.length === 0">
      </q-btn>
    </div>
  </div>

  <div class="row q-mb-sm">
    <div class="col">

      <div class="parcel-list-summary row items-center justify-between q-mb-sm q-px-xs">
        <div class="parcel-list-counts row items-center">
          <div class="text-body2 text-grey-8">
            전체 <strong class="text-dark">{{ pagination.rowsNumber }}</strong>건 / 현재 페이지 {{ parcelList.length }}건
          </div>
          <q-badge
            v-if="selectedList.length > 0"
            outline
            color="primary"
            :label="`${selectedList.length}건 선택`" />
        </div>
        <div class="parcel-state-help row items-center text-caption text-grey-7">
          <q-icon name="info" size="16px" class="q-mr-xs" />
          진행상태는 배송상품 처리 단계, 포장상태는 현장 포장 작업,
          콘솔상태는 포장 완료 후 콘솔 연결 단계입니다.
        </div>
      </div>

      <q-table
        class="parcel-table"
        flat
        bordered
        separator="cell"
        virtual-scroll
        v-model:selected="selectedList"
        selection="multiple"
        :rows-per-page-options="[50, 100, 200]"
        :rows="parcelList"
        :columns="columns"
        v-model:pagination="tablePagination"
        :loading="loading"
        @request="requestPage"
        no-data-label="조회된 배송상품이 없습니다."
        row-key="id">

        <!-- 헤더의 전체선택 체크박스 -->
        <template v-slot:header-selection="props">
          <q-checkbox v-model="props.selected" :disable="loading" />
        </template>

        <!-- 바디 커스텀 렌더링 -->
        <template v-slot:body="props">
          <q-tr 
            :props="props"
            class="parcel-table-row"
            @click="onRowClick($event, props.row)">
            <!-- 선택 체크박스 셀을 반드시 넣어줍니다 -->
            <q-td auto-width>
              <q-checkbox v-model="props.selected" :disable="loading" @click.stop />
            </q-td>

            <!-- 나머지 컬럼 -->
            <q-td
              v-for="col in props.cols"
              :key="col.name"
              :props="props"
              :class="{
                'parcel-description-cell': col.name === 'itemNames',
                'parcel-state-cell': ['statusName', 'packingOwner', 'packingStatus', 'tempConsolStatus', 'trackingState'].includes(col.name)
              }">
              <template v-if="col.name === 'orderId'">
                <q-btn
                  flat
                  dense
                  no-caps
                  color="primary"
                  :label="col.value || `ID ${props.row.id}`"
                  :aria-label="`주문 ${col.value || props.row.id} 상세 열기`"
                  @click.stop="openParcelDetails(props.row)" />
              </template>
              <template v-else-if="col.field === 'isPrinted'">
                <q-badge
                  v-if="col.value == 1"
                  color="red"
                  label="출력"
                  aria-label="운송장이 출력된 주문">
                  <q-tooltip>운송장이 출력된 주문입니다.</q-tooltip>
                </q-badge>
                <span v-else class="text-grey-5" aria-label="운송장 미출력">-</span>
              </template>
              <template v-else-if="col.name === 'packingStatus'">
                <q-badge :color="getPackingStatusColor(props.row.packingStatus)" text-color="white">
                  {{ getPackingStatusLabel(props.row) }}
                </q-badge>
              </template>
              <template v-else-if="col.field === 'tempConsolStatus'">
                <q-badge :color="getTempConsolStatusColor(props.row.tempConsolStatus)" text-color="white">
                  {{ getTempConsolStatusLabel(props.row.tempConsolStatus) }}
                </q-badge>
              </template>
              <template v-else-if="col.field === 'trackingState'">
                <div class="row items-center justify-center no-wrap q-gutter-xs">
                  <q-badge :color="getTrackingStatusColor(props.row.trackingState)" text-color="white">
                    {{ props.row.trackingState || '미조회' }}
                  </q-badge>
                  <q-btn
                    dense
                    round
                    flat
                    size="sm"
                    icon="local_shipping"
                    :aria-label="`${props.row.hblNo || 'H/BL 미등록'} 배송조회`"
                    :disable="!props.row.hblNo"
                    @click.stop="openTrackingModal(props.row)">
                    <q-tooltip>{{ props.row.hblNo ? '배송조회' : 'H/BL 번호 없음' }}</q-tooltip>
                  </q-btn>
                </div>
              </template>
              <template v-else-if="col.name === 'packingOwner'">
                <q-badge
                  outline
                  :color="getPackingOwnerColor(props.row.packingOwner)">
                  {{ getPackingOwnerLabel(props.row.packingOwner) }}
                </q-badge>
              </template>
              <template v-else-if="col.name === 'statusName'">
                <q-badge outline color="primary">
                  {{ col.value || '-' }}
                </q-badge>
              </template>
              <template v-else-if="col.field === 'itemNames'">
                <div class="parcel-description-text">
                  {{ col.value || '-' }}
                  <q-tooltip
                    v-if="col.value"
                    anchor="bottom middle"
                    self="top middle"
                    :offset="[0, 8]"
                    style="max-width: 500px; white-space: normal; overflow-wrap: anywhere;">
                    {{ col.value }}
                  </q-tooltip>
                </div>
              </template>
              <template v-else>
                {{ col.value }}
              </template>
            </q-td>
          </q-tr>
        </template>

      </q-table>
    </div>
  </div>

  <teleport to="body">
    <q-dialog 
      v-model="modifyModalShow">

      <ParcelInfoForm
        :selectedParcel="selectedList"
        :user="userType"
        @refresh-list="reloadParcelList"
        @close-modal="modifyModalShow = false"
        />

    </q-dialog>
  </teleport>

  <!-- 콘솔목록 -->
  <teleport to="body">
    <q-dialog 
      v-model="consolModalShow">

      <ConsolListModal
        :selectedOrders="selectedList" 
        @refresh-list="reloadParcelList"
        @close-modal="consolModalShow = false; selectedList = []"
        />

    </q-dialog>
  </teleport>


  <teleport to="body">
    <q-dialog v-model="packingOwnerDialogShow" persistent>
      <PackingOwnerChangeDialog v-if="packingOwnerDialogShow" :orders="packingOwnerOrders"
        @close="packingOwnerDialogShow = false" @refresh="refreshAfterPackingOwnerChange" />
    </q-dialog>
  </teleport>

  <!-- PDF 운송장 -->
  <teleport to="body">
		<q-dialog 
      v-model="pdfModalShow"
      persistent>

      <PdfPreviewer
        :parcelList="selectedList"
        @close-modal="closePdfPreview"/>
        
    </q-dialog>
	</teleport>

  <teleport to="body">
		<q-dialog
      v-model="trackingModalShow"
      persistent>

      <q-card style="width: 760px; max-width: 95vw;">
        <q-card-section>
          <div class="row items-start justify-between q-col-gutter-md">
            <div class="col">
              <div class="text-h6">배송조회</div>
              <div class="text-caption text-grey-7">
                {{ trackingTarget?.orderId || trackingTarget?.id }} / {{ trackingTarget?.hblNo }}
              </div>
            </div>
            <div class="col-auto">
              <q-btn
                @click="trackingModalShow = false"
                flat v-close-popup round dense icon="close" />
            </div>
          </div>
        </q-card-section>

        <q-card-section class="q-pt-none">
          <div v-if="trackingLoading" class="row justify-center q-py-lg">
            <q-spinner color="primary" size="32px" />
          </div>

          <template v-else>
            <div class="row q-col-gutter-sm q-mb-md">
              <div class="col-12 col-sm-4">
                <div class="tracking-summary">
                  <div class="text-caption text-grey-7">현재 상태</div>
                  <q-badge
                    :color="getTrackingStatusColor(trackingInfo?.track_state || trackingInfo?.trackState)"
                    text-color="white">
                    {{ trackingInfo?.track_state || trackingInfo?.trackState || '미조회' }}
                  </q-badge>
                </div>
              </div>
              <div class="col-12 col-sm-4">
                <div class="tracking-summary">
                  <div class="text-caption text-grey-7">마지막 조회</div>
                  <div>{{ trackingInfo?.last_checked_at || trackingInfo?.lastCheckedAt || '-' }}</div>
                </div>
              </div>
              <div class="col-12 col-sm-4">
                <div class="tracking-summary">
                  <div class="text-caption text-grey-7">마지막 처리</div>
                  <div>{{ trackingInfo?.last_event_status || trackingInfo?.lastEventStatus || '-' }}</div>
                </div>
              </div>
            </div>

            <q-banner
              v-if="trackingInfo?.last_error_message || trackingInfo?.errorMessage"
              class="q-mb-md bg-red-1 text-red-9">
              {{ trackingInfo?.last_error_message || trackingInfo?.errorMessage }}
            </q-banner>

            <q-list bordered separator v-if="trackingInfo?.details?.length">
              <q-item v-for="(detail, index) in trackingInfo.details" :key="`${detail.sortNo || index}-${detail.date}-${detail.time}`">
                <q-item-section>
                  <q-item-label>
                    {{ detail.status || '-' }}
                    <span class="text-grey-7 q-ml-sm">{{ detail.location || '-' }}</span>
                  </q-item-label>
                  <q-item-label caption>
                    {{ detail.date || '-' }} {{ detail.time || '' }}
                  </q-item-label>
                  <q-item-label caption v-if="detail.remark">
                    {{ detail.remark }}
                  </q-item-label>
                </q-item-section>
              </q-item>
            </q-list>

            <div v-else class="text-grey-7 q-py-md">
              저장된 배송 진행 내역이 없습니다.
            </div>
          </template>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn
            flat
            color="primary"
            icon="refresh"
            label="수동 재조회"
            :loading="trackingLoading"
            @click="refreshTracking" />
        </q-card-actions>
      </q-card>
    </q-dialog>
	</teleport>


  <teleport to="body">
		<q-dialog 
      v-model="tempListModalShow"
      persistent>
      
      <q-card style="width: 1180px; max-width: 95vw;">
        <q-card-section>
          <div class="row items-start justify-between q-col-gutter-md">
            <div class="col">
              <div class="text-h6">임시콘솔목록</div>
              <div class="text-caption text-grey-7">
                포장완료 후 실제 콘솔 연결을 기다리는 DB 기준 대기 목록입니다.
              </div>
            </div>
            <div class="col-auto">
              <q-btn
                @click="closeModal()" 
                flat v-close-popup round dense icon="close" />
            </div>
          </div>
        </q-card-section>

        <q-card-section class="q-pt-none">
          <div class="row q-col-gutter-sm q-mb-md">
            <div class="col-6 col-md-3">
              <div class="temp-consol-summary">
                <div class="text-caption text-grey-7">대기 오더</div>
                <div class="text-h6">{{ tempConsolSummary.orderCount }}</div>
              </div>
            </div>
            <div class="col-6 col-md-3">
              <div class="temp-consol-summary">
                <div class="text-caption text-grey-7">선택</div>
                <div class="text-h6">{{ tempConsolSummary.selectedCount }}</div>
              </div>
            </div>
            <div class="col-6 col-md-3">
              <div class="temp-consol-summary">
                <div class="text-caption text-grey-7">파트너</div>
                <div class="text-h6">{{ tempConsolSummary.partnerCount }}</div>
              </div>
            </div>
            <div class="col-6 col-md-3">
              <div class="temp-consol-summary">
                <div class="text-caption text-grey-7">총 수량 / 중량</div>
                <div class="text-h6">{{ tempConsolSummary.totalQty }} / {{ tempConsolSummary.totalWeight }}kg</div>
              </div>
            </div>
          </div>

          <div class="row q-mb-sm">
            <div class="col">
              <q-btn
                color="primary"
                size="md"
                label="선택 건 콘솔 연결"
                :disable="selectedTempConsolList.length === 0"
                @click="callConsolModal('inTemp')" />
              <q-btn
                color="negative"
                outline
                size="md"
                label="선택 해제"
                class="q-ml-sm"
                :disable="selectedTempConsolList.length === 0"
                @click="clearSelectedTempConsol" />
            </div>
            <div class="col-auto">
              <q-btn
                color="grey-7"
                outline
                size="md"
                icon="refresh"
                label="새로고침"
                :loading="tempConsolLoading"
                @click="loadTempConsolList" />
              <q-btn
                color="grey-7"
                size="md"
                label="전체 비우기"
                class="q-ml-sm"
                :disable="tempConsolList.length === 0"
                @click="emptyConsol" />
            </div>
          </div>

          <div class="row">
            <div class="col">
              <q-table
                class="my-sticky-virtscroll-table"
                virtual-scroll
                v-model:selected="selectedTempConsolList"
                selection="multiple"
                :loading="tempConsolLoading"
                :rows-per-page-options="[0]"
                :virtual-scroll-sticky-size-start="48"
                :rows="tempConsolList"
                :columns="tempConsolColumns"
                row-key="id">
                <template v-slot:body-cell-itemNames="props">
                  <q-td :props="props" class="temp-consol-item-name">
                    {{ props.value || '-' }}
                  </q-td>
                </template>
              </q-table>

            </div>
          </div>
        </q-card-section>
      </q-card>

    </q-dialog>
  </teleport>

</template>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.parcel-list-summary {
  min-height: 28px;
}

.parcel-state-help {
  line-height: 1.4;
}

.parcel-table-row {
  cursor: pointer;
}

.parcel-description-cell {
  width: 280px;
  min-width: 200px;
  max-width: 320px;
}

.parcel-description-text {
  width: 100%;
  max-width: 280px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.parcel-state-cell {
  min-width: 104px;
  white-space: nowrap;
}

.parcel-list-summary,
.parcel-list-counts {
  gap: 8px;
}

:deep(.parcel-table thead tr) {
  background: #f5f7fa;
}

:deep(.parcel-table tbody tr:hover) {
  background: #f4f8ff;
}

@media (max-width: 700px) {
  .parcel-list-summary {
    align-items: flex-start;
    flex-direction: column;
  }

  .parcel-state-help {
    width: 100%;
  }
}

.temp-consol-item-name {
  max-width: 280px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.temp-consol-summary {
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 8px 10px;
  background: #fafafa;
}

.tracking-summary {
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 8px 10px;
  background: #fafafa;
  min-height: 58px;
}
</style>
